import { useState, forwardRef } from 'react';
import VisibilityOff from '@mui/icons-material/VisibilityOffOutlined';
import Visibility from '@mui/icons-material/VisibilityOutlined';
import { Icon, InputAdornment } from '@mui/material';
import TextField, { TextFieldProps } from '../TextField';

type Props = TextFieldProps & {
  clearFormValue?: () => void;
  isFormValueDirty?: boolean;
};

const PasswordField = forwardRef(
  ({ clearFormValue, isFormValueDirty, ...props }: Props, ref) => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const clearPasswordInitialVal = () => {
      if (!isFormValueDirty) {
        clearFormValue?.();
      }
    };

    const isFormField = !!clearFormValue;
    const isRevealButtonHidden = isFormField && !isFormValueDirty;

    return (
      <TextField
        ref={ref}
        variant="outlined"
        type={isPasswordVisible ? 'text' : 'password'}
        onFocus={() => clearPasswordInitialVal()}
        InputProps={{
          endAdornment: !isRevealButtonHidden && (
            <InputAdornment position="start">
              <Icon
                sx={{
                  color: 'content.primary',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  if (isRevealButtonHidden) return;
                  clearPasswordInitialVal();
                  setIsPasswordVisible((prev) => !prev);
                }}
              >
                {isPasswordVisible ? <VisibilityOff /> : <Visibility />}
              </Icon>
            </InputAdornment>
          ),
        }}
        {...props}
      />
    );
  },
);

export default PasswordField;
